/** Class names, leaving out the empty ones: cx("a", busy && "b") → "a" or "a b". */
export function cx(...names: Array<string | false | null | undefined>): string {
  return names.filter(Boolean).join(" ");
}
